import React, { useEffect, useState } from "react";
import MaterialTable from "@material-table/core";
import { Box, Paper, Fab } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../services/api";
import PmesDialog from "./PmesDialog";

export default function PmesList() {
  const [rows, setRows] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editing, setEditing] = useState(null);

  const loadData = async () => {
    const res = await api.http.get("/pmes");
    setRows(res.data);
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleAdd = () => {
    setEditing(null);
    setOpenDialog(true);
  };

  const handleEdit = (rowData) => {
    setEditing(rowData);
    setOpenDialog(true);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper variant="outlined" sx={{ width: "100%", my: 3 }}>
        <MaterialTable
          title="PMEs"
          columns={[
            { title: "CNPJ", field: "cnpj" },
            { title: "Empresa", field: "nomeEmpresa" },
            { title: "Código SENAI", field: "codigoSenai" },
            { title: "Segmento Industrial", field: "segmentoIndustrial" },
            { title: "Porte", field: "porteEmpresa" },
            { title: "Horas Previstas", field: "totalHorasPrevisto" },
            { title: "Unidade SENAI", field: "unidadeSenai" },
            { title: "Especialista", field: "nomeEspecialista" },
            { title: "Início Atendimento", field: "dataInicioAtendimento", type: "date" },
            { title: "Fim Regulamentar", field: "dataFimRegulamentar", type: "date" },
            { title: "Tipo Apoio", field: "tipoApoioConsultores" },
            { title: "Consultor Técnico", field: "consultorTecnico" },
            { title: "Sprint", field: "sprintBacklog" },
            { title: "Contato GIZ", field: "contatoGiz" },
            { title: "Reunião 1", field: "dataReuniao1", type: "date" },
            { title: "Reunião 2", field: "dataReuniao2", type: "date" },
            { title: "Reunião 3", field: "dataReuniao3", type: "date" },
            { title: "Fim Previsto/Realizado", field: "dataFimPrevisto", type: "date" },
            { title: "Saldo Dias Execução", field: "saldoDiasExecucao" },
            { title: "Situação Diagnóstico BI", field: "situacaoDiagnosticoBi" },
            { title: "Valor Projeto", field: "valorProjeto", type: "currency" },
            { title: "Valor Investimentos Realizados", field: "valorInvestimentosRealizados", type: "currency" },
            { title: "Status Reunião Impl", field: "statusReuniaoImpl" },
            { title: "Modalidade Impl", field: "modalidadeImpl" },
            { title: "Priorização Contato PME", field: "priorizacaoContato" },
            { title: "Status Apoio Decisão", field: "statusApoioDecisao" },
            { title: "Motivos Não Impl", field: "motivosNaoImpl" },
            { title: "Elegibilidade FAEE", field: "elegibilidadeFaee" },
            { title: "Enquadramento FINEP", field: "enquadramentoFinep" },
            { title: "Pendência Doc", field: "pendenciaDoc" },
            { title: "Status Financiamento", field: "statusFinanciamento" },
            { title: "Responsável Próx Passo", field: "responsavelProximoPasso" },
            { title: "Data Atualização", field: "dataAtualizacaoStatus", type: "date" },
            { title: "Status Implementação", field: "statusImpl" },
            { title: "Data 1º Contato", field: "dataPrimeiroContato", type: "date" },
            { title: "Comentários PMO", field: "comentariosPmo" },
            { title: "Volume MEEs Impl", field: "volumeMeesImpl", type: "numeric" },
            { title: "Ano Início", field: "anoInicio", type: "numeric" }
          ]}
          data={rows}
          options={{
            paging: true,
            search: true,
            exportButton: true,
            headerStyle: {
              whiteSpace: 'nowrap',
            },
            cellStyle: {
              whiteSpace: 'nowrap',
            }
          }}
          style={{
            overflowX: "auto",
          }}
          onRowClick={(evt, rowData) => handleEdit(rowData)}
        />

        <Fab
          color="primary"
          aria-label="nova PME"
          sx={{ position: "absolute", bottom: 16, right: 16 }}
          onClick={handleAdd}
        >
          <AddIcon />
        </Fab>
      </Paper>

      {openDialog && (
        <PmesDialog
          open={openDialog}
          onClose={() => {
            setOpenDialog(false);
            loadData();
          }}
          editing={editing}
        />
      )}
    </Box>
  );
}
